import {ApolloLink, Observable} from '@apollo/client';

import type {InternalOperation} from '@sail/data';

function getV1ContextMismatchType(accountId: unknown, id: unknown) {
  if (accountId == null) {
    return 'account_id_missing';
  }

  if (id == null) {
    return 'id_missing';
  }

  return 'value_mismatch';
}

export default function createV1ContextMismatchTelemetryLink() {
  return new ApolloLink((operation: InternalOperation, forward) => {
    return new Observable(function v1MismatchTelemetryLinkSubscriptionFn(
      observer,
    ) {
      const context = operation.getContext();
      const observabilityFns = context.observabilityFns;
      const operationName = operation.operationName || '<unknown>';
      const v1 = (operation.variables || {}).v1Context;

      if (typeof v1 === 'object' && v1 !== null) {
        const accountId = 'accountId' in v1 ? v1.accountId : undefined;
        const id = 'id' in v1 ? v1.id : undefined;

        if (accountId !== id && Math.random() < 0.001) {
          observabilityFns?.analytics?.track('v1_context_mismatch', {
            project: 'sail_core',
            operation_name: operationName,
            v1_account_id: accountId,
            v1_context_id: id,
            v1_context_mismatch_type: getV1ContextMismatchType(accountId, id),
          });
        }
      }

      return forward(operation).subscribe({
        next: function handleNextFromLink(result) {
          observer.next(result);
        },

        error: function handleErrorFromLink(error: unknown) {
          observer.error(error);
        },

        complete: () => {
          observer.complete();
        },
      });
    });
  });
}
